import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { buildAuthLoadingSelector, buildAuthUserSelector } from 'store/selectors/auth.selector';
import { connect } from 'react-redux';
import { checkAuth } from 'store/dispatchers/auth.dispatchers';
import { CONSTANTS } from 'services/constants';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';

function AuthorizeAccess({
    loading, authUser, component: Component, dispatch,
})
{
    const checkUserAuthentication = async () =>
    {
        if (!authUser && !loading)
        {
            await dispatch(checkAuth());
        }
    };

    useEffect(() =>
    {
        checkUserAuthentication();
    }, []);

    if (!authUser || loading)
    {
        return (
            <div className="tw-w-full tw-h-screen tw-relative tw-flex tw-content-center tw-flex-wrap">
                <div className="tw-m-auto tw-text-center tw-w-24">
                    <p className="font-sm tw-mt-2"><LoadingSpinner loading /> Loading</p>
                </div>
            </div>
        );
    }

    if (!authUser)
    {
        window.location.replace(CONSTANTS.AUTH.LOGIN_ENDPOINT);
    }

    return <Component />;
}

AuthorizeAccess.propTypes = {
    dispatch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    authUser: PropTypes.object,
    component: PropTypes.any,
};

const mapStateToProps = () =>
{
    const authUserSelector = buildAuthUserSelector();
    const loadingSelector = buildAuthLoadingSelector();

    return (state) => ({
        authUser: authUserSelector(state),
        loading: loadingSelector(state),
    });
};

export default connect(mapStateToProps)(AuthorizeAccess);
